import { AvatarCurrency } from '../Avatar/AvatarCurrency';
import { AvatarIcon } from '../Avatar/AvatarIcon';
import { BankIcon } from '../../icons/BankIcon';
import { ListItem, ListItemAvatar, ListItemProps, ListItemText } from '@mui/material';
import { useMemo } from 'react';
import { formatIbanForDisplay } from '@razz-team/utils';
import { AvatarBadge } from '../Avatar/AvatarBadge';

export interface BusinessBeneficiaryListItemContentProps {
  currency: string;
  displayName: string | null | undefined;
  businessName: string;
  accountNumber: string;
}

const BADGE_SIZE = 16;

export function BusinessBeneficiaryListItemContent({
  currency,
  displayName,
  businessName,
  accountNumber,
}: BusinessBeneficiaryListItemProps) {
  const name = displayName ?? businessName;

  const iban = useMemo(() => formatIbanForDisplay(accountNumber), [accountNumber]);

  return (
    <>
      <ListItemAvatar>
        <AvatarBadge type="icon" icon={<AvatarCurrency currency={currency} size={BADGE_SIZE} />}>
          <AvatarIcon icon={<BankIcon />} />
        </AvatarBadge>
      </ListItemAvatar>
      <ListItemText primary={`${name} · ${currency}`} secondary={iban} />
    </>
  );
}

export type BusinessBeneficiaryListItemProps = ListItemProps<
  'li',
  BusinessBeneficiaryListItemContentProps
>;

export function BusinessBeneficiaryListItem({
  currency,
  displayName,
  businessName,
  accountNumber,
  ...props
}: BusinessBeneficiaryListItemProps) {
  return (
    <ListItem {...props}>
      <BusinessBeneficiaryListItemContent
        currency={currency}
        displayName={displayName}
        businessName={businessName}
        accountNumber={accountNumber}
      />
    </ListItem>
  );
}
